import { useUser } from "./useUser";

export const useAuthenticated = () => {
  const user = useUser();
  return user !== null;
};
